import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    encabezado: {
        paddingBottom: 0,
    },
});

export default useStyles;
